interface TipVariant {
  id: number;
  title: string;
  price: string;
  oldPrice: string;
  inStock: boolean;
}

export default function initTipProduct() {
  Alpine.data('tipProduct', () => ({
    id: 0,
    color: '',
    variants: [] as TipVariant[],
    selectedVariant: null as TipVariant | null,
    salePrice: '',
    oldPrice: '',
    title: '',
    description: '',
    url: '',
    submitting: false,
    purchasableIdInput: null as HTMLInputElement | null,
    selectVariant(variant: TipVariant) {
      this.selectedVariant = variant;
      this.salePrice = this.selectedVariant.price ?? this.salePrice;
      this.oldPrice = this.selectedVariant.oldPrice ?? '';
      if (this.purchasableIdInput) {
        this.purchasableIdInput.value = `${this.selectedVariant.id}`;
      }
    },
    selectColor(
      id: number,
      variants: TipVariant[],
      selectedVariantId: number,
      title: string,
      description: string,
      url: string,
      color: string,
    ) {
      this.id = id;
      this.color = color;
      this.variants = variants;
      const selectedVariants = this.variants.filter((variant: TipVariant) => variant.id === selectedVariantId);
      if (selectedVariants.length) {
        this.selectVariant(selectedVariants[0]);
      }
      this.title = title;
      this.description = description;
      this.url = url;
    },
    isColorSelected(id: number) {
      return this.id === id;
    },
    handleSubmit(event: FormDataEvent) {
      if (this.submitting) {
        return;
      }
      this.submitting = true;

      const form = event.target as HTMLFormElement;
      fetch('/', {
        method: 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        redirect: 'manual',
      })
        .then(() => {
          this.submitting = false;
          // @ts-ignore
          htmx.trigger('#cart', 'refresh');
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    initFirstProduct(
      id: number,
      variants: TipVariant[],
      selectedVariantId: number,
      title: string,
      description: string,
      url: string,
      color: string,
    ) {
      this.purchasableIdInput = this.$el.querySelector('.purchasable-id') as HTMLInputElement;
      this.selectColor(
        id,
        variants,
        selectedVariantId,
        title,
        description,
        url,
        color,
      );
    },
  }));
}
